import moment from "moment";
import React from "react";
import ThumbsDown from "../assets/ThumbsDown.png";
import ThumbsUp from "../assets/ThumbsUp.png";
import CrossIcon from "../assets/cross.svg";
import ExclamationIcon from "../assets/exclamation.svg";
import { extractZoneAndPassForM500FromTableLimits } from "./tlog/tlog-data-mapper";

const getIconForStatus = (status) => {
  switch (status?.toLowerCase()) {
    case "(Select All)":
      return "(Select All)";
    case "false":
      return <img src={ThumbsDown} alt="Thumbs Down" />;
    case "true":
      return <img src={ThumbsUp} alt="Thumbs Up" />;
    case "ex":
      return <img src={ExclamationIcon} alt="Exclamation" />;
    case "cross":
      return <img src={CrossIcon} alt="Cross" />;
    case "-":
      return "-";
    default:
      return "-";
  }
};

const getExportValueForStatus = (status) => {
  switch (status) {
    case "false":
      return "Thumbs Down";
    case "true":
      return "Thumbs Up";
    case "ex":
      return "Exclamation";
    case "cross":
      return "Cross";
    case "-":
      return "-";
    default:
      return "-";
  }
};

const getStationName = (stationNumber) => {
  return stationNumber == "-"
    ? "-"
    : stationNumber == "0"
    ? "IWM"
    : `Station ${stationNumber}`;
};

const formatWeldStartTime = (
  date,
  time = false,
  onlyTime = false,
  isYear = false
) => {
  if (date == "" || isNaN(date)) {
    return "-";
  }
  if (isYear) {
    return moment(1000000 * date).format("MMM-DD,YYYY, HH:mm:ss");
  }

  if (onlyTime) {
    return moment(1000000 * date).format("HH:mm:ss");
  }

  return time
    ? moment(1000000 * date).format("MMM-DD, HH:mm:ss")
    : moment(1000000 * date).format("MMM DD, YYYY");
};

const formatWeldStartTimeLive = (
  date,
  time = false,
  onlyTime = false,
  isYear = false
) => {
  if (date == "" || isNaN(date)) {
    return "-";
  }

  const timestamp = date * 1000;

  if (isYear) {
    return moment(timestamp).format("DD-MMM-YYYY, HH:mm");
  }

  if (onlyTime) {
    return moment(timestamp).format("HH:mm");
  }

  return time
    ? moment(timestamp).format("DD-MMM-YYYY, HH:mm")
    : moment(timestamp).format("DD-MMM-YYYY");
};

const formatTime = (date) => {
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
};

const getPassNamePassZone = ({
  avgTlogs,
  station_number,
  pass_name,
  tableLimitData,
  job_number,
  isM500,
}) => {
  if (station_number != "0") {
    // if (weldNumber == "Unknown") {
    //   return "-";
    // }
    let passNamesExtracted = avgTlogs?.map((ite) => ite[pass_name]);

    if (passNamesExtracted?.length != avgTlogs?.length) {
      return "!";
    }

    if (isM500) {
      const m500PassNames = passNamesExtracted?.map((ite) => {
        return extractZoneAndPassForM500FromTableLimits(
          tableLimitData,
          job_number,
          ite
        )?.PassNum;
      });

      let uniquePassNamesM500 = [...new Set([...m500PassNames])];

      if (uniquePassNamesM500?.length > 1 || uniquePassNamesM500?.length == 0) {
        return "!";
      } else {
        return uniquePassNamesM500?.[0];
      }
    }

    let tableLimitPresent = tableLimitData?.filter(
      (tableLimit) => tableLimit.job_number == job_number
    );

    if (tableLimitPresent.length == 0) {
      return "-";
    }

    let filteredAvgTlogs = [];

    if (job_number) {
      filteredAvgTlogs = avgTlogs?.filter(
        (ite) => ite.job_number == job_number
      );
    } else {
      filteredAvgTlogs = avgTlogs;
    }

    filteredAvgTlogs = filteredAvgTlogs?.map((tlog) => {
      return tableLimitData?.find(
        (tableLimit) =>
          tableLimit.zone_name == tlog[pass_name] &&
          tableLimit.job_number == job_number
      );
    });

    let uniquePassNames = [
      // eslint-disable-next-line no-unsafe-optional-chaining
      ...new Set([...filteredAvgTlogs?.map((ite) => ite?.pass_name)]),
    ];

    if (uniquePassNames?.length > 1 || uniquePassNames?.length == 0) {
      return "!";
    } else {
      return uniquePassNames?.[0] || "!";
    }
  } else {
    return "Root IWM";
  }
};

const getPassNameSingleTlog = ({
  tlogsSingle,
  station_number,
  tableLimitData,
}) => {
  if (station_number == "0") {
    return "Root IWM";
  }

  // if (weld_number == "Unknown") {
  //   return "-";
  // }

  let isTableLimitPresent = tableLimitData?.filter(
    (tableLimit) => tableLimit.job_number == tlogsSingle?.job_number
  );

  if (isTableLimitPresent.length == 0) {
    return "-";
  }

  if (!tlogsSingle?.trail_pass_name && !tlogsSingle?.lead_pass_name) {
    return "!";
  }

  let passNameExtracted =
    tlogsSingle?.trail_pass_name || tlogsSingle?.lead_pass_name;

  let allPassNames = [];

  if (tlogsSingle?.job_number) {
    allPassNames = tableLimitData?.filter(
      (tableLimit) => tableLimit.job_number == tlogsSingle?.job_number
    );
  } else {
    allPassNames = tableLimitData;
  }

  allPassNames = allPassNames?.filter(
    (tableLimit) => tableLimit.zone_name == passNameExtracted
  );

  allPassNames = allPassNames?.map((ite) => ite.pass_name);

  let uniquePassNames = [...new Set([...allPassNames])];

  if (uniquePassNames?.length > 1 || uniquePassNames?.length == 0) {
    return "!";
  } else {
    return uniquePassNames?.[0] || "!";
  }
};

const allParamsValues = {
  arcCurrent: "Current",
  arcVolts: "Volts",
  frequency: "Frequency",
  target: "Target",
  horizontalBias: "Horizontal Bias",
  travelSpeed: "Travel Speed",
  wireSpeed: "Wire Speed",
  heat: "Heat",
  trueEnergy: "True Energy",
  oscillationWidth: "Oscillation Width",
  totalWireConsumed: "Total Wire Consumed",
  bandDiameter: "Band Diameter",
  wireDiameter: "Wire Diameter",
  loggingDistance: "Logging Distance",
  calculatedHeat: "Calculated Heat",
};

const defaultParamsValues = [
  "Current",
  "Volts",
  "Wire Speed",
  "Travel Speed",
  "Oscillation Width",
];

const redCircleAvailableForColumns = [
  "Heat",
  "Volts",
  "Current",
  "Wire Speed",
  "Travel Speed",
  "Calculated Heat",
  "Oscillation Width",
  "True Energy",
];

const isColumnEnabledForRedCircle = ({
  weldParamsShowColumns,
  currentColumn,
  jobNumber,
}) => {
  let jobNumberExists = weldParamsShowColumns?.find(
    (ite) => ite.job_number == jobNumber
  );

  if (redCircleAvailableForColumns.includes(currentColumn)) {
    if (jobNumberExists) {
      if (jobNumberExists.enabledKeys.includes(currentColumn)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }
};

const sampleReportColumns = {
  switch: "Avg",
  params: [
    "Arc Current",
    "Arc Volts",
    "Frequency",
    "Target",
    "Horizontal Bias",
    "Travel Speed",
    "Wire Speed",
    "Heat",
    "True Energy",
    "Oscillation Width",
    "Total Wire Consumed",
    "Band Diameter",
    "Wire Diameter",
    "Logging Distance",
  ],
  units: {
    ArcCurrent: "A",
    ArcVolts: "V",
    "Travel Speed": "in/min",
    "True Energy": "kJ/in",
    Heat: "kJ/in",
    "Wire Speed": "in/min",
    "Oscillation Width": "in",
    Frequency: "cyc/m",
  },
};

const data360LiveGetReportColumns = (currentProject) => {
  const testReportColumns = {
    switch: "Avg",
    params: [],
    units: {},
  };

  if (currentProject?.report_columns) {
    const columnMapping = {
      current: "Arc Current",
      volts: "Arc Volts",
      frequency: "Frequency",
      target: "Target",
      horizontal_bias: "Horizontal Bias",
      travel_speed: "Travel Speed",
      wire_speed: "Wire Speed",
      heat: "Heat",
      true_energy: "True Energy",
      oscillation_width: "Oscillation Width",
      total_wire_consumed: "Total Wire Consumed",
      band_diameter: "Band Diameter",
      wire_diameter: "Wire Diameter",
      logging_distance: "Logging Distance",
    };

    // Add enabled columns to params
    Object.entries(currentProject.report_columns).forEach(([key, value]) => {
      if (value && columnMapping[key]) {
        testReportColumns.params.push(columnMapping[key]);
      }
    });

    // Map units
    if (currentProject.units) {
      const unitMapping = {
        current: "ArcCurrent",
        volts: "ArcVolts",
        travel_speed: "Travel Speed",
        true_energy: "True Energy",
        heat: "Heat",
        wire_speed: "Wire Speed",
        oscillation_width: "Oscillation Width",
        frequency: "Frequency",
      };

      Object.entries(currentProject.units).forEach(([key, value]) => {
        if (unitMapping[key]) {
          testReportColumns.units[unitMapping[key]] = value;
        }
      });
    }
  }

  return testReportColumns;
};

const logDataHelperFunctions = {
  getIconForStatus,
  getExportValueForStatus,
  getStationName,
  formatWeldStartTime,
  formatWeldStartTimeLive,
  formatTime,
  getPassNamePassZone,
  getPassNameSingleTlog,
  allParamsValues,
  sampleReportColumns,
  defaultParamsValues,
  redCircleAvailableForColumns,
  isColumnEnabledForRedCircle,
  data360LiveGetReportColumns,
};

export { logDataHelperFunctions };
